import React, { useEffect, useRef } from 'react';

import dixonDesktop from '../../images/dixonscreenshot.png';
import dixonMobile  from '../../images/dixonmobile.png';
import lsDesktop    from '../../images/lsscreenshot.png';
import lsMobile     from '../../images/lsmobilescreenshot.png';
import pwDesktop    from '../../images/pwscreenshot.png';
import pwMobile     from '../../images/pwmobilescreenshot.png';

const PROJECTS = [
  {
    type:    'Business Website · Client Work',
    name:    'TG Hardscapes',
    desc:    'A professional site for a local hardscaping and landscaping business — built to look great, load fast, and turn visitors into customers on any device.',
    desktop: lsDesktop,
    mobile:  lsMobile,
    alt:     'TG Hardscapes website',
    links:   [{ label: 'Live Site', href: 'https://tghardscapes.com' }],
  },
  {
    type:    'Business Website · Client Work',
    name:    'Pressure Washing Co.',
    desc:    'A clean, conversion-focused site for a local pressure washing business. Fast, mobile-ready, and built to show up in local searches.',
    desktop: pwDesktop,
    mobile:  pwMobile,
    alt:     'Pressure washing business website',
    links:   [{ label: 'Live Site', href: 'https://pressurewashing-drab.vercel.app/' }],
  },
  {
    type:    'Business Website · Client Work',
    name:    'Dixon Insurance Agency',
    desc:    'A professional website for a local insurance agency — clean, trustworthy, and built to help clients find the coverage they need and get in touch fast.',
    desktop: dixonDesktop,
    mobile:  dixonMobile,
    alt:     'Dixon Insurance Agency website',
    links:   [{ label: 'Live Site', href: 'https://dixonagencync.com/' }],
  },
];

const Project = () => {
  const revealRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add('visible');
      }),
      { threshold: 0.12 }
    );
    const els = revealRefs.current;
    els.forEach((el) => el && observer.observe(el));
    return () => els.forEach((el) => el && observer.unobserve(el));
  }, []);

  const ref = (i) => (el) => { revealRefs.current[i] = el; };

  return (
    <section id="projects" className="section projects-section">
      <div className="section-header reveal" ref={ref(0)}>
        <span className="section-num">03.</span>
        <h2 className="section-title">Projects</h2>
        <div className="section-line" />
      </div>
      <p className="section-sub reveal" ref={ref(99)}>
        Every site I build looks and works great on phones, tablets, and desktops - hover the preview in the corner to see the mobile version.
      </p>

      <div className="projects-grid">
        {PROJECTS.map((p, i) => (
          <article
            key={p.name}
            className={`project-card reveal reveal-delay-${i % 3}`}
            ref={ref(i + 1)}
          >
            <div className="project-image-wrap">
              <img src={p.desktop} alt={p.alt} />
              <div className="project-image-overlay" />
              {p.mobile && (
                <div className="project-mobile-badge">
                  <img src={p.mobile} alt={`${p.alt} mobile`} />
                </div>
              )}
            </div>
            <div className="project-body">
              <p className="project-type">{p.type}</p>
              <h3 className="project-name">{p.name}</h3>
              <p className="project-desc">{p.desc}</p>
              <div className="project-footer">
                {p.links.length > 0 ? p.links.map((l) => (
                  <a
                    key={l.label}
                    href={l.href}
                    target="_blank"
                    rel="noreferrer"
                    className="project-link"
                  >
                    <span className="project-link-icon">↗</span>
                    {l.label}
                  </a>
                )) : (
                  <span className="project-link-muted">Coming Soon</span>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Project;
